/**
 * Placeholder rows while a page is being fetched.
 *
 * A single "Carregando…" line collapses the table to one row, so the whole
 * page jumps: the header moves up, the pager moves up, and whatever somebody
 * was about to click is somewhere else by the time the rows arrive. Rows of
 * the right shape hold the layout still, which matters most on exactly the
 * action that causes it -- pressing "next page" and having the table reflow
 * under the cursor.
 *
 * `rows` should be the page size, so the table is the height it is about to
 * be rather than the height of whatever the last page happened to hold.
 */
export function TableSkeleton({ columns, rows }: { columns: number; rows: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, row) => (
        <tr key={row} aria-hidden>
          {Array.from({ length: columns }, (_, column) => (
            <td key={column} className="px-3 py-2">
              {/*
                Varied widths, because a column of identical bars reads as a
                rendering artefact rather than as content on its way.
              */}
              <div
                className="bg-fill-neutral-weak h-3 animate-pulse rounded"
                style={{ width: `${[70, 45, 85, 55, 60, 40, 75][column % 7]}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
